<template>
  <v-row align="start" class="row--35">
    <v-col lg="12" md="12" sm="12" cols="12" order="2" order-md="1">
      <div class="text-center section-title mb--50">
        <span class="subtitle" v-reveal>Feel free to reach out</span>
        <h2 class="heading-title" v-reveal="60">Contact Me</h2>
        <dl class="contact-grid" v-reveal="120">
          <div class="contact-grid__row">
            <dt>Call</dt>
            <dd><a class="link im-hover" href="tel:+65 8575 3341">+65 8575 3341</a></dd>
          </div>
          <div class="contact-grid__row">
            <dt>Email</dt>
            <dd><a class="link im-hover" href="mailto:doem1997@gmail.com">doem1997 [AT] gmail [DOT] com</a></dd>
          </div>
          <div class="contact-grid__row">
            <dt>WeChat</dt>
            <dd>
              <a class="link im-hover" @click="copyWeChatToClipboard">kRnQ6VLF</a>
              <transition name="copied-pop">
                <span v-if="isWeChatCopied" class="copied-badge">Copied</span>
              </transition>
            </dd>
          </div>
          <div class="contact-grid__row">
            <dt>Address</dt>
            <dd><a class="link im-hover" href="https://goo.gl/maps/UZjW8jaYk7q6ySqq6" target="_blank"
                rel="noopener">80 Stamford Rd, Singapore 178902</a></dd>
          </div>
        </dl>

        <!-- <div class="rn-address" :class="address.isAddress">
          <div class="icon" v-html="iconSvg(address.icon)"></div>
          <div class="inner">
            <h4 class="heading-title">{{ address.title }}</h4>
            <p>
              <a :href="address.to1">{{ address.info1 }}</a>
            </p>
            <p>
              <a :href="address.to2">{{ address.info2 }}</a>
            </p>
          </div>
        </div> -->
      </div>

      <!-- <div class="form-wrapper">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <ValidationProvider name="name" rules="required" v-slot="{ errors }">
              <label>
                <input type="text" v-model="formData.name" placeholder="Your Name *" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
              <label>
                <input type="text" rules="required|email" v-model="formData.email" placeholder="Your email *" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="subject" rules="required" v-slot="{ errors }">
              <label>
                <input type="text" v-model="formData.subject" placeholder="Write a Subject" />
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <ValidationProvider name="message" rules="required" v-slot="{ errors }">
              <label>
                <textarea v-model="formData.message" placeholder="Your Message"></textarea>
                <span class="inpur-error">{{ errors[0] }}</span>
              </label>
            </ValidationProvider>

            <button class="btn-default" type="submit" value="submit">
              Submit Now
            </button>
          </form>
        </ValidationObserver>
      </div> -->
    </v-col>
    <v-col lg="6" md="6" sm="12" cols="12" order="1" order-md="2">
      <div class="thumbnail mb_md--40 mb_sm--40">
        <slot name="contact-img"></slot>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      formData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      isWeChatCopied: false,
    };
  },
  methods: {
    onSubmit() {
      console.log(this.formData);
    },
    copyWeChatToClipboard() {
      navigator.clipboard.writeText('kRnQ6VLF').then(() => {
        this.isWeChatCopied = true;
        setTimeout(() => {
          this.isWeChatCopied = false;
        }, 1400);
      }).catch(err => {
        console.error('Could not copy WeChat ID: ', err);
      });
    },
  },
};

</script>

<style lang="scss">
.contact-grid {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 28px;
  row-gap: 14px;
  justify-content: center;
  align-items: baseline;
  margin: 8px auto 0;

  &__row {
    display: contents;
  }

  dt {
    text-align: right;
    font-family: var(--font-primary);
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--color-primary);
    opacity: 0.65;
  }

  dd {
    margin: 0;
    text-align: left;
    font-family: var(--font-primary);
    font-size: 1.05rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 10px;

    .link {
      font-size: 1.05rem;
      font-weight: 400;
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 767px) {
    grid-template-columns: max-content minmax(0, 1fr);
    column-gap: 18px;
    row-gap: 12px;
    justify-content: start;
    max-width: 420px;

    dd,
    dd .link {
      font-size: 0.98rem;
    }
  }
}

.copied-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 50em;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0A0908;
  background: var(--color-primary);
}

.copied-pop-enter-active,
.copied-pop-leave-active {
  transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
}

.copied-pop-enter,
.copied-pop-leave-to {
  opacity: 0;
  transform: translateX(-4px) scale(0.9);
}

.form-wrapper label input,
.form-wrapper label textarea {
  margin-bottom: 0;
}

.form-wrapper label {
  margin-bottom: 20px;
}
</style>
